export interface Normal<T> {
  [id: string]: T;
}
export const normalize = <T>(data: T[], id?: string): Normal<T> => {
  let normalizedData: Normal<T> = {};
  data.forEach((datum: any) => {
    normalizedData = {
      ...normalizedData,
      [datum[id || 'id'] as keyof T]: datum,
    };
  });
  return normalizedData;
};
